import z from 'zod';

export enum BucketTypeEnum {
  TOKEN = 'TOKEN',
  CASH = 'CASH',
}

export const BucketSchema = z.object({
  name: z.string().min(1),
  type: z.enum(BucketTypeEnum),
});

export type IBucketSchema = z.infer<typeof BucketSchema>;

export const BucketResponseSchema = BucketSchema.extend({
  id: z.string(),
  name: z.string(),
  type: z.enum(BucketTypeEnum),
  locked: z.boolean(),
  createdBy: z.string(),
  createDate: z.string(),
  lastModifiedBy: z.string(),
  modifyDate: z.string(),
});
export type IBucketResponseSchema = z.infer<typeof BucketResponseSchema>;

export const BucketUpdatePayloadSchema = BucketSchema.extend({
  id: z.string(),
});
export type IBucketUpdatePayloadSchema = z.infer<
  typeof BucketUpdatePayloadSchema
>;
